import angular from 'angular';
import router from 'angular-ui-router';

import 'angularjs-datepicker';
import 'angularjs-datepicker/dist/angular-datepicker.min.css';

import authorised from './_authorised';
import schedulelist from './schedulelist';
import driverlist from './driverlist';
import driveredit from './driveredit';
import storelist from './storelist';
import storeedit from './storeedit';
import auditlist from './auditlist';

// Create module
const _moduleName = 'authorised';
const _module = angular.module(_moduleName, [
    router,
    '720kb.datepicker'
]);

// Register components
_module.config(authorised);
_module.config(schedulelist);
_module.config(driverlist);
_module.config(driveredit);
_module.config(storelist);
_module.config(storeedit);
_module.config(auditlist);

_module.run(setupStoreId);

setupStoreId.$inject = ['$rootScope', 'StoresService'];

function setupStoreId($rootScope, StoresService) {
    $rootScope.$on('$stateChangeStart', updateStoreId);

    function updateStoreId(ev, toState, toParams) {
        if (toParams.storeId) return;
        StoresService.getStore().then(store => toParams.storeId = store.storeId);
    }
}

// Export module name
export default _moduleName;



// WEBPACK FOOTER //
// ./src/js/components/authorised/index.js